<template>
    <v-card class="function-tabs-card" outlined>
        <v-tabs v-model="activeTab" background-color="transparent" height="36">
            <v-tab>{{ $t("monitor.exposureChart.title") }}</v-tab>
            <v-tab>{{ $t("monitor.PNLRanking.title") }}</v-tab>
            <v-tab>{{ $t("monitor.VolumeRanking.title") }}</v-tab>
        </v-tabs>
        <div class="tab-content">
            <ExposureChart v-if="activeTab == 0" class="tab-content" />
            <PNLRanking v-if="activeTab == 1" style="height: 100%" />
            <VolumeRanking v-if="activeTab == 2" style="height: 100%" />
        </div>
    </v-card>
</template>

<script>
import ExposureChart from "./ComponentExposureChart";
import PNLRanking from "./PNLRanking";
import VolumeRanking from "./VolumeRanking";

export default {
    components: {
        ExposureChart,
        PNLRanking,
        VolumeRanking
    },
    data() {
        return {
            activeTab: 0,
        };
    },
    watch: {
        activeTab(nv) {
            localStorage.setItem("functionalTabKey", nv);
        },
    },
    mounted() {
        const savedTab = localStorage.getItem("functionalTabKey");
        if (savedTab !== null) {
            this.activeTab = Number(savedTab);
        }
    },
};
</script>

<style scoped>
.function-tabs-card {
    height: 100%;
}
.tab-content {
    height: calc(100% - 36px);
}
.function-tabs-card >>> .v-tab {
    min-width: 0;
    padding: 0 6px; 
}
</style>
